<template>
  <div class="first-empty content-center">
    <div class="content-center-column content-div">
      <div class="txt-div content-center">
        <img src="../../assets/cps2/add-logo.png" width="45px" height="26px" />
        <div>您还没有舱单管理数据，来建立您的第一份数据吧！</div>

      </div>
      <div class="flex">
        <div class="box-div cursor-pointer" @click="addCps">
          <div class="img-div">
            <img src="../../assets/cps2/add.png" />
          </div>
          <div class="content-center text-div">新建舱单</div>
        </div>
        <div class="box-div cursor-pointer" style="margin-left: 160px;" @click="exportCps">
          <div class="img-div">
            <img src="../../assets/cps2/adds.png" />
          </div>
          <div class="content-center text-div">表格导入</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FirstEmpty",
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    
  },
  data() {
    return {
    }
  },
  methods: {
    // 新建舱单	
    addCps(){
      this.$emit('addCps')
    },
    // 导入
    exportCps(){
      this.$emit('exportCps')
    },
  }
};
</script>

<style scoped lang="less">
.first-empty {
  width: 100%;
  height: 100vh;
  min-height: 480px;
  // background: #fff;
  // background: linear-gradient(180deg, #5a94e9 0%, #8ec0ee 100%);

  // padding: 0px 0 50px 0;
  .content-div {
    background: #fff;
    width: 100%;
    height: 100%;
    // margin: 0 48px;
    // padding: 100px 150px;
    // margin-top: 95px;
    border-radius: 4px;
    .txt-div {
      height: 33px;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 33px;
      margin-bottom: 40px;
      img {
        margin-right: 18px;
      }
    }

    .box-div:hover {
      box-shadow: 0px 2px 4px 4px rgba(221, 221, 221, 0.21),
        0px 2px 4px 4px rgba(221, 221, 221, 0.21);
    }
    .box-div {
      width: 300px;
      height: 340px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #d0d0d0;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      opacity: 1 !important; //不可去掉，否则会被别的页面的box-div样式污染显示不了
      .img-div {
        flex: 1;
        width: 100%;
        height: 100%;
        img {
          width: 300px;
          height: 290px;
        }
      }
      .text-div {
        height: 56px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        text-align: center;
      }
    }
  }
}
</style>
